module.exports = __webpack_public_path__ + "img/info-03.8dde51bd.jpg";